<template>
    <div class="qksm qksm1 page">
        <div class="nogap">
            <h4>一、关于收支预算总表的说明</h4>
            <p>
                按照综合预算的原则，{{$store.state.divData.divname}}所有收入和支出均纳入部门预算管理。按照收支平衡原则，{{$store.state.divData.divname}}{{$parent.year}}年收支总预算均为{{isMoney(T1.收入.总计)}}万元。
            </p>
            <p v-if="T1.收入.包括.length>0">
                收入包括：
                <template v-for="(item, idx) in T1.收入.包括">
                    {{item.name}}{{idx==T1.收入.包括.length-1?'；':'、'}}
                </template>
            </p>
            <p v-if="T1.支出.包括.length>0">
                支出包括：
                <template v-for="(item, idx) in T1.支出.包括">
                    {{item.name}}{{idx==T1.支出.包括.length-1?'。':'、'}}
                </template>
            </p>
        </div>
        <p></p>
    </div>
</template>
<script>
    export default {
        name: "qksm1",
        data() {
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm,
            }
        },
        props: {
            T1: {
                type: Object,
                default: "",
            },
        },
    };
</script>